import { render, staticRenderFns } from "./SelectCompetences.vue?vue&type=template&id=c81ab280"
import script from "./SelectCompetences.vue?vue&type=script&lang=js"
export * from "./SelectCompetences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports